import { motion } from 'framer-motion';

export const AnimatedLoading = ({ label = 'Loading' }: { label?: string }) => {
  return (
    <div className='flex items-center justify-center'>
      {label}
      <span className='ml-1 flex space-x-1'>
        {[0, 1, 2].map(i => (
          <motion.span
            key={i}
            className='inline-block'
            animate={{ y: ['0%', '-20%', '0%'] }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              delay: i * 0.2,
              ease: 'easeInOut'
            }}
          >
            .
          </motion.span>
        ))}
      </span>
    </div>
  );
};
